import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { GTMTracking, LottieAnimation } from '@common/ui/general';
import { useMediaQuery } from '@common/hooks';

import AlumniConnectBox from '@alumni_v2/ui/SidebarModal/AlumniConnectBox';
import AlumniConnectBoxRevamp
  from '@alumni_v2/ui/SidebarModal/AlumniConnectBoxRevamp';
import ProfileBox from '@alumni_v2/ui/SidebarModal/ProfileBox';
import YoutubeEmbed from '@alumni_v2/ui/SidebarModal/YoutubeEmbed';

import arrowIcon from '@alumni_v2/images/svg/arrow.svg';
import linkedinIcon from '@alumni_v2/images/svg/linkedin.svg';
import upArrowIcon from '@alumni_v2/images/svg/upArrowIcon.svg';

import Confetti from
  '@alumni_v2/images/lottie/desktop-confetti.lottie';
import MobileConfetti from
  '@alumni_v2/images/lottie/mobile-confetti.lottie';

import styles from './ProfileContent.module.scss';

const ProfileContent = ({
  userId,
  name,
  profileImg,
  preScalerRole,
  designation,
  location,
  preScalerText,
  preScalerImg,
  postScalerText,
  postScalerImg,
  salaryHike,
  availableForQnA,
  programDetails,
  linkedinId,
  linkedinPost,
  content,
  collegeName,
  deegree,
  workExperience,
  videoBlog,
  rating,
  setSidebarModalStage,
  onModalClose,
  isModalOpen,
}) => {
  const { tablet } = useMediaQuery();
  const isPaidUser = useSelector((state) => state.reviews.paidUser);
  const { showAlumniConnect, showNewAcsBanner } = window.__INITIAL_STATE__;

  const acsBannerUi = () => {
    if (showNewAcsBanner) {
      return (
        <AlumniConnectBoxRevamp
          name={name}
          setSidebarModalStage={setSidebarModalStage}
          onModalClose={onModalClose}
          userId={userId}
          isModalOpen={isModalOpen}
        />
      );
    }

    return (
      <AlumniConnectBox
        name={name}
        setSidebarModalStage={setSidebarModalStage}
        onModalClose={onModalClose}
        userId={userId}
      />
    );
  };

  const companyTransitionUi = () => (
    <>
      <div className={classNames(styles.companyContainer,
        { [styles.companyContainerRevamp]: showNewAcsBanner })}
      >
        <div
          className={styles.transitionContainer}
        >
          {[1, -1].map(item => (
            <LottieAnimation
              autoPlay
              loop
              mode="normal"
              src={tablet ? MobileConfetti : Confetti}
              className={styles.lottie}
              style={{
                display: 'flex',
                position: 'absolute',
                right: item * 20,
                top: 7,
              }}
            />
          ))}
          <div className={styles.transitionBox}>
            <div className={styles.preScalerInfo}>
              <div className={styles.courseText}>Pre Scaler</div>

              <div className={styles.preScalerLogo}>
                {preScalerImg ? (
                  <img src={preScalerImg} alt="preScaler Company" />
                ) : (
                  <div className={styles.companyName}>
                    {preScalerText}
                  </div>
                )}
              </div>

              <div className={styles.roleInfo}>
                {preScalerRole && preScalerRole}
              </div>
            </div>

            <div className={styles.arrow}>
              <img src={arrowIcon} alt="to" />
            </div>

            <div className={styles.postScalerInfo}>
              <div className={styles.courseText}>Post Scaler</div>

              <div className={styles.postScalerLogo}>
                {postScalerImg ? (
                  <img src={postScalerImg} alt="postScaler Company" />
                ) : (
                  <div className={styles.companyName}>
                    {postScalerText}
                  </div>
                )}
              </div>

              <div className={styles.roleInfo}>
                {designation}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.hikeContainer}>
        {salaryHike ? (
          <div className={styles.hikeText}>
            <img src={upArrowIcon} alt="up-arrow" />
            <div>
              {salaryHike}
              % Salary Hike after Scaler
            </div>
          </div>
        ) : null}

      </div>
    </>
  );

  return (
    <>
      <ProfileBox
        name={name}
        profileImg={profileImg}
        designation={designation}
        postScalerText={postScalerText}
        location={location}
        availableForQnA={availableForQnA}
        programDetails={programDetails}
        linkedinId={linkedinId}
        collegeName={collegeName}
        deegree={deegree}
        workExperience={workExperience}
        rating={rating}
      />
      {showNewAcsBanner && companyTransitionUi()}
      {showAlumniConnect && !isPaidUser
        ? (
          <div className={styles.askQueBanner}>
            {acsBannerUi()}
          </div>
        ) : null}

      {!showNewAcsBanner && companyTransitionUi()}
      {
        linkedinPost && (
          <>
            <div className={styles.reviewsContainer}>
              <div className={styles.reviewHeading}>
                Reviews and Blogs
              </div>
              <div className={styles.reviewBlock}>
                {content && (
                  <div className={styles.reviewOverview}>
                    {content}
                    ...
                  </div>
                )}
                <GTMTracking
                  component="button"
                  gtmEventType="cta"
                  gtmEventAction="click"
                  gtmEventResult="profile_linkedin_review"
                  gtmEventCategory="alumni_directory"
                  className={styles.linkedinReview}
                  gtmEventData={{
                    click_type: 'read_review_on_linkedin',
                    click_text: name,
                  }}
                >
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={linkedinPost}
                    className={styles.linkedINBtn}
                  >
                    <img src={linkedinIcon} alt="linked Icon" />
                    <div className={styles.btnText}>
                      Read review on LinkedIn
                    </div>
                  </a>
                </GTMTracking>
              </div>
            </div>
          </>
        )
      }

      {
        videoBlog && (
          <div className={styles.youtubeReviewContainer}>
            <div className={styles.reviewHeading}>
              Reviews by
              {' '}
              {name}
              {' '}
              on YouTube
            </div>
            <div className={styles.videoContainer}>
              <YoutubeEmbed
                youtubeLink={videoBlog}
              />
            </div>
          </div>
        )
      }
    </>
  );
};

export default ProfileContent;
